module.exports = __webpack_public_path__ + "static/media/founder.8cb8fabb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Story/assets/founder.png
// module id = 617
// module chunks = 0